<template>
  <div class="page-channels" id="page-channels">
    <div class="mb-2">
      <Breadcrumb :items=breadCrumbs() v-if="loaded"/>
    </div>
    <!-- <div class="d-flex justify-content-end" v-if="loaded">
      <button class="btn btn-success mb-2" @click="updateAllTranslations()">
        Update All DeepL Translations
      </button>
    </div> -->
    <div>
      <tabs :items="tabs" v-model="tab" :with-content="true" @switch="switchTab">
        <template v-for="(languageTab,index) in tabs" v-slot:[tabName(languageTab)]>
          <div class="list d-none d-md-block left-edge float-right mb-3" :key="index">
            <p class="head-line">
              <search-filter
                v-model="filter"
                :disabled="!loaded || pending"
                :placeholder="$t('pages.project-page.filter-tip')"
                class="ml-3"
              />
              <SubmitButton
                @click="onSearch()"
                variant="primary"
                class="btn-outline-primary ml-2"
                :disabled="pending && !loaded || updatePending"
                :loading="pending"
                inline
              >
                {{ $t('buttons.search') }}
              </SubmitButton>
            </p>
          </div>
          <div class="plans-table" v-if="loaded" :key="index+languageTab">
            <table class="w-100">
              <thead>
                <tr>
                  <th class="w-name">{{ $t('pages.project-translations.headers.key') }}</th>
                  <th class="w-name text-center">{{ $t('pages.project-translations.headers.description') }}</th>
                  <th class="w-name">Project Page</th>
                  <th class="w-name">{{ $t('pages.project-translations.headers.translation') }}</th>
                </tr>
              </thead>
              <tbody v-if="loaded && projectKeys.length === 0">
                <tr>
                  <td colspan="4" class="w-empty">{{ $t('pages.project-key.no-project-key') }}</td>
                </tr>
              </tbody>
              <tbody v-for="row in projectKeys" :key="row.keywordId">
                <tr class="separator before" v-if="row.translation.is_automated === 1"></tr>
                <tr v-if="row.translation.is_automated === 1">
                  <td>
                    ${{ row.keywordKey }}
                  </td>
                  <td class="text-center">
                    <span>{{ descriptionLimited(row.keywordDescription) }} </span>
                    <icon
                      class="icon mr-1 mb-1"
                      width="12" height="12"
                      type="info-circle"
                      v-b-tooltip:page-channels.bottom="row.keywordDescription"
                      v-if="row.keywordDescription.length > 20"
                    />
                  </td>
                  <td>
                    <span>{{ descriptionLimited(row.project_page) }} </span>
                    <icon
                      class="icon mr-1 mb-1"
                      width="12" height="12"
                      type="info-circle"
                      v-b-tooltip:page-channels.bottom="row.project_page"
                      v-if="row.project_page.length > 20"
                    />
                  </td>
                  <td class="actions">
                    <p
                      style="text-align: right;"
                      v-bind:style="{color: row.translation.translation ? 'black' : 'red'}">
                      {{ row.englishTranslation }}
                    </p>
                    <ValidationObserver ref="form-translation">
                      <ValidatedField
                        class="float-right w-85"
                        rules="required"
                        type="textarea"
                        v-model="row.translation.translation"
                        :placeholder="$t('pages.project-translations.placeholders.add-translation')"
                        :name="`translation-${row.keywordId}`"
                        disabled
                      />
                    </ValidationObserver>
                  </td>
                </tr>
                <tr class="separator after" v-if="row.translation.is_automated === 1"></tr>
              </tbody>
            </table>
          </div>
          <pagination
            :key="languageTab+index"
            v-if="loaded && totalCount"
            :perPage="20"
            :currentPage="currentPage"
            :totalRows="totalCount"
            @update:current-page="updateCurrentPage($event)"
          />
        </template>
      </tabs>

    </div>
  </div>
</template>

<script>
  import { mapState, mapGetters, mapActions } from 'vuex';

  export default {
    name: 'AutomatedDeepLTranslations',
    data: () => ({
      tabs: [],
      activeTab: null,
      currentPage: 1,
      disabledSubmit: false,
      filter: '',
      withoutTranslations: false,
    }),
    async created() {
      if (!this.isAdmin) {
        this.tabs.push({
          id: this.user.language.id,
          title: this.user.language.name,
          iso: this.user.language.iso,
        });
        this.activeTab = this.user.language.id;
      } else {
        /* Adding language tab */
        await this.fetchLanguages();
        this.languages.forEach((language) => {
          if (!this.activeTab) {
            if (language.iso !== 'en') {
              this.activeTab = language.id;
            }
          }
          if (language.iso !== 'en') {
            this.tabs.push({ id: language.id, title: language.name, iso: language.iso });
          }
        });
      }
      await this.show();
    },
    computed: {
      ...mapGetters('user', ['user', 'isAdmin']),
      ...mapGetters('languages', ['languages']),
      ...mapGetters('automateddeeplTranslations', ['loaded', 'noProjectKeys', 'projectKeys']),
      ...mapState('automateddeeplTranslations', ['error', 'pending', 'updatePending', 'totalCount', 'projectPage', 'project']),
      tab: {
        get() { return this.activeTab; },
        set(tab) {
          this.activeTab = tab;
        },
      },
    },
    methods: {
      ...mapActions('automateddeeplTranslations', ['fetchAllTranslations', 'updateDeeplTranslations']),
      ...mapActions('languages', { fetchLanguages: 'fetchData' }),
      async show() {
        await this.fetchAllTranslations({
          currentPage: this.currentPage,
          projectId: this.$route.params.id,
          languageId: this.activeTab,
          q: this.filter,
          withoutTranslations: this.withoutTranslations,
        });
      },
      async switchTab() {
        await this.show();
      },
      tabName(tab) {
        return `tab(${tab.id})`;
      },
      async updateAllTranslations() {
        try {
          await this.updateDeeplTranslations();
          this.$toastr.s({
            title: this.$t('All DeepL Translations Updated'),
            msg: '',
            timeout: 3000,
            progressbar: false,
          });
          await this.show();
        } catch (error) {
          this.$toastr.e(error);
        }
      },
      updateCurrentPage(currentPage) {
        this.currentPage = currentPage;
        this.show();
      },
      breadCrumbs() {
        return [
          {
            text: this.$t('pages.dashboard.title'),
            to: { name: 'dashboard' },
          },
          {
            text: this.project.name,
            to: { name: 'automateddeepltranslations' },
          },
          {
            text: this.$t('pages.automateddeepltranslations.title'),
            active: true,
          },
        ];
      },
      async onSearch() {
        if (this.filter.length === 0 || this.filter.length >= 3) {
          await this.show();
        }
      },
      descriptionLimited(description) {
        if (description.length > 20) {
          return `${description.substring(0, 20) }...`;
        }
        return description;
      },
    },
  };
</script>

<style scoped>

</style>
